export const STORAGE_KEY_PREFIX = 'MS:';
export const STORAGE_KEY_APP_NAVIGATION_VISIBILITY = `${STORAGE_KEY_PREFIX}appNavigationVisibility`;
export const STORAGE_KEY_AUTH_TOKENS = `${STORAGE_KEY_PREFIX}authTokens`;
export const STORAGE_KEY_DRAFT = `${STORAGE_KEY_PREFIX}draft:`;
export const STORAGE_KEY_DRAFT_ID = `${STORAGE_KEY_PREFIX}draftId`;
export const STORAGE_KEY_ELEVATE_TOKENS = `${STORAGE_KEY_PREFIX}elevateTokens`;
export const STORAGE_KEY_LOCALE = `${STORAGE_KEY_PREFIX}locale`;
export const STORAGE_KEY_REDIRECT_URI = `${STORAGE_KEY_PREFIX}redirectUri`;
export const STORAGE_KEY_THEME = `${STORAGE_KEY_PREFIX}theme`;
